import { Quote } from "lucide-react";
import { useState } from "react";

export default function TestimonialCard({ t, idx = 0 }) {
  const [expanded, setExpanded] = useState(false);
  const isLong = t.quote.length > 320;
  const display = expanded || !isLong ? t.quote : t.quote.slice(0, 320) + "…";
  return (
    <article
      data-testid={`testimonial-card-${idx}`}
      className="reveal relative border border-cream/15 bg-olive/95 text-cream p-10 md:p-14 flex flex-col"
      style={{ transitionDelay: `${idx * 100}ms` }}
    >
      <Quote className="text-taupe" size={36} />
      <p className="mt-6 font-serif italic text-2xl md:text-3xl leading-snug text-cream">
        “{display}”
      </p>
      {isLong && (
        <button
          onClick={() => setExpanded((v) => !v)}
          data-testid={`testimonial-toggle-${idx}`}
          className="mt-6 self-start text-[0.7rem] tracking-[0.22em] uppercase text-taupe hover:text-cream transition-colors"
        >
          {expanded ? "Show less" : "Read full story"}
        </button>
      )}
      <div className="mt-8 pt-6 border-t border-cream/20 flex items-center gap-4">
        {t.image && (
          <img
            src={t.image}
            alt={t.name}
            className="h-12 w-12 rounded-full object-cover border border-cream/25 shrink-0"
          />
        )}
        <div>
          <div className="font-serif text-xl text-cream">{t.name}</div>
          <div className="text-[0.7rem] tracking-[0.22em] uppercase text-taupe">{t.role}</div>
        </div>
      </div>
    </article>
  );
}
